import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import useAnimateCss, { useAnimateCssStagger } from "../../hooks/useAnimateCss";


import imgBanha from "../../assets/images/projects/new/banha-horr.webp";
import imgCapital from "../../assets/images/projects/new/new-capital.webp";
import img30June from "../../assets/images/projects/new/30-june.webp";
import imgFangary from "../../assets/images/projects/new/fangary.webp";
import imgObour from "../../assets/images/projects/new/obour.webp";
import imgBadr from "../../assets/images/projects/new/badr.webp";
import iconRoad from "../../assets/icons/ROAD.webp";
import iconBuilding from "../../assets/icons/building-icon.webp";

const projects = [
  {
    image: imgBanha,
    nameKey: "project-1-name",
    bodyKey: "project-1-body",
    icon: iconRoad,
  },
  {
    image: imgCapital,
    nameKey: "project-2-name",
    bodyKey: "project-2-body",
    icon: iconBuilding,
  },
  {
    image: img30June,
    nameKey: "project-3-name",
    bodyKey: "project-3-body",
    icon: iconRoad,
  },
  {
    image: imgFangary,
    nameKey: "project-4-name",
    bodyKey: "project-4-body",
    icon: iconRoad,
  },
  {
    image: imgObour,
    nameKey: "project-5-name",
    bodyKey: "project-5-body",
    icon: iconBuilding,
  },
  {
    image: imgBadr,
    nameKey: "project-6-name",
    bodyKey: "project-6-body",
    icon: iconBuilding,
  },
];

function ProjectsGallery() {
  const { t } = useTranslation();
  const headRef = useAnimateCss("animate__fadeInDown", 0,   0.15);
  const subRef  = useAnimateCss("animate__fadeInUp",   150, 0.15);
  const gridRef = useAnimateCssStagger("animate__fadeInUp", 110, 0.06);
  const btnRef  = useAnimateCss("animate__bounceIn",   0,   0.15, 700);

  return (
    <section className="projects-section">
      <div className="container">
        {/* Heading */}
        <div className="mb-5">
          <h2 className="projects-heading" ref={headRef as any}>{t("Mega Projects")}</h2>
          <p className="inner-page-text" ref={subRef as any}>
            {t(
              "Our Steel Rebar approved and supplied in Iconic Construction sites in Egypt :",
            )}
          </p>
        </div>

        {/* 2-col grid */}
        <div className="row g-4" ref={gridRef as any}>
          {projects.map((p, i) => (
            <div key={i} className="col-lg-6">
              <Link
                to="/projects/mega-projects"
                className="pg-card"
                aria-label={t(p.nameKey)}
              >
                {/* Card header: icon + title */}
                <div className="pg-card-header">
                  <div className="pg-card-icon">
                    <img src={p.icon} alt="" />
                  </div>
                  <h6 className="pg-card-title">{t(p.nameKey)}</h6>
                </div>

                {/* Description */}
                <p className="pg-card-desc">{t(p.bodyKey)}</p>

                {/* Photo */}
                <img src={p.image} alt={t(p.nameKey)} className="pg-card-img" />
              </Link>
            </div>
          ))}
        </div>

        <div className="text-center mt-5" ref={btnRef as any}>
          <Link to="/projects/mega-projects" className="btn-primary-custom">
            {t("More")}
          </Link>
        </div>
      </div>
    </section>
  );
}

export default ProjectsGallery;
